var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h2", [_vm._v("Zoho Integration")]),
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [_vm._v("Connection Status")]),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.statusLoading,
                  },
                  on: { click: _vm.checkStatus },
                },
                [_vm._v(" Check Connection ")]
              ),
            ],
            1
          ),
          _vm.status
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _c("strong", [_vm._v("Client ID:")]),
                          _vm._v(" " + _vm._s(_vm.status.config?.clientId)),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Client Secret:")]),
                          _vm._v(" " + _vm._s(_vm.status.config?.clientSecret)),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Organization ID:")]),
                          _vm._v(" " + _vm._s(_vm.status.config?.orgId)),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _c("strong", [_vm._v("Refresh Token:")]),
                          _vm._v(" " + _vm._s(_vm.status.config?.refreshToken)),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Webhook Secret:")]),
                          _vm._v(
                            " " + _vm._s(_vm.status.config?.webhookSecret)
                          ),
                        ]),
                        _c(
                          "p",
                          [
                            _c("strong", [_vm._v("Token Status:")]),
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.status.tokenStatus?.valid
                                    ? "success"
                                    : "danger",
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.status.tokenStatus?.valid
                                        ? "Valid"
                                        : "Invalid"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.status.tokenStatus?.error
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "red",
                                      "margin-left": "10px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.status.tokenStatus.error) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.statusError
            ? _c("div", { staticStyle: { color: "red" } }, [
                _vm._v(" " + _vm._s(_vm.statusError) + " "),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Sales Orders", name: "salesorders" } },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "15px" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "Filter by Status", clearable: "" },
                      on: { change: _vm.loadSalesOrders },
                      model: {
                        value: _vm.salesOrderStatus,
                        callback: function ($$v) {
                          _vm.salesOrderStatus = $$v
                        },
                        expression: "salesOrderStatus",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "All", value: "" } }),
                      _c("el-option", {
                        attrs: { label: "Draft", value: "draft" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Confirmed", value: "confirmed" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Packed", value: "packed" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Shipped", value: "shipped" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Delivered", value: "delivered" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Fulfilled", value: "fulfilled" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Cancelled", value: "cancelled" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.loadSalesOrders },
                    },
                    [_vm._v(" Refresh ")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.salesOrdersLoading,
                      expression: "salesOrdersLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.salesOrders },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "salesorder_number",
                      label: "Order #",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "customer_name", label: "Customer" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "status", label: "Status", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getStatusType(row.status),
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(row.status))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "total", label: "Total", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(row.currency_symbol) +
                                _vm._s(row.total) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "Date", width: "120" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Actions", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewOrderDetails(row)
                                  },
                                },
                              },
                              [_vm._v("View")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Items", name: "items" } },
            [
              _c(
                "el-input",
                {
                  staticStyle: { width: "300px", "margin-bottom": "15px" },
                  attrs: { placeholder: "Search items..." },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.loadItems.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.itemSearch,
                    callback: function ($$v) {
                      _vm.itemSearch = $$v
                    },
                    expression: "itemSearch",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "append" },
                      on: { click: _vm.loadItems },
                      slot: "append",
                    },
                    [_vm._v("Search")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.itemsLoading,
                      expression: "itemsLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.items },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "sku", label: "SKU", width: "150" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "Name" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "rate", label: "Price", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(row.currency_symbol || "$") +
                                _vm._s(row.rate) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "stock_on_hand",
                      label: "Stock",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "status", label: "Status", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    row.status === "active"
                                      ? "success"
                                      : "info",
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(row.status))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Contacts", name: "contacts" } },
            [
              _c(
                "el-input",
                {
                  staticStyle: { width: "300px", "margin-bottom": "15px" },
                  attrs: { placeholder: "Search contacts..." },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.loadContacts.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.contactSearch,
                    callback: function ($$v) {
                      _vm.contactSearch = $$v
                    },
                    expression: "contactSearch",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "append" },
                      on: { click: _vm.loadContacts },
                      slot: "append",
                    },
                    [_vm._v("Search")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.contactsLoading,
                      expression: "contactsLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.contacts },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "contact_name", label: "Name" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "email", label: "Email" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "phone", label: "Phone", width: "150" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "contact_type",
                      label: "Type",
                      width: "120",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("el-tag", { attrs: { size: "small" } }, [
                              _vm._v(_vm._s(row.contact_type)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Invoices", name: "invoices" } },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "15px" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "Filter by Status", clearable: "" },
                      on: { change: _vm.loadInvoices },
                      model: {
                        value: _vm.invoiceStatus,
                        callback: function ($$v) {
                          _vm.invoiceStatus = $$v
                        },
                        expression: "invoiceStatus",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "All", value: "" } }),
                      _c("el-option", {
                        attrs: { label: "Draft", value: "draft" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Sent", value: "sent" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Viewed", value: "viewed" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Paid", value: "paid" },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "Partially Paid",
                          value: "partially_paid",
                        },
                      }),
                      _c("el-option", {
                        attrs: { label: "Overdue", value: "overdue" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Void", value: "void" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.loadInvoices },
                    },
                    [_vm._v(" Refresh ")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.invoicesLoading,
                      expression: "invoicesLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.invoices },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "invoice_number",
                      label: "Invoice #",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "customer_name", label: "Customer" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "status", label: "Status", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getInvoiceStatusType(row.status),
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(row.status))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "total", label: "Total", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(row.currency_symbol) +
                                _vm._s(row.total) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "Date", width: "120" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Packages", name: "packages" } },
            [
              _c(
                "el-card",
                {
                  staticClass: "box-card",
                  staticStyle: { "margin-bottom": "20px" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-header",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("Sync Packages to System")])]
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 16 } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "350px" },
                            attrs: {
                              type: "daterange",
                              "range-separator": "to",
                              "start-placeholder": "Start date",
                              "end-placeholder": "End date",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.syncDateRange,
                              callback: function ($$v) {
                                _vm.syncDateRange = $$v
                              },
                              expression: "syncDateRange",
                            },
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: {
                                type: "info",
                                loading: _vm.syncPreviewLoading,
                              },
                              on: { click: _vm.previewSync },
                            },
                            [_vm._v(" Preview Sync ")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: {
                                type: "success",
                                loading: _vm.syncLoading,
                              },
                              on: { click: _vm.executeSync },
                            },
                            [_vm._v(" Sync to System ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.syncPreview
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "15px" } },
                        [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("Sync Preview")]
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("el-statistic", {
                                    attrs: {
                                      title: "Total Packages",
                                      value: _vm.syncPreview.total_packages,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("el-statistic", {
                                    attrs: {
                                      title: "Total Devices",
                                      value: _vm.syncPreview.total_devices,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("el-statistic", {
                                    attrs: {
                                      title: "New Devices",
                                      value: _vm.syncPreview.new_devices,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("el-statistic", {
                                    attrs: {
                                      title: "Existing Devices",
                                      value: _vm.syncPreview.existing_devices,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.syncPreview.new_skus &&
                          _vm.syncPreview.new_skus.length > 0
                            ? _c(
                                "div",
                                { staticStyle: { "margin-top": "15px" } },
                                [
                                  _c(
                                    "el-alert",
                                    {
                                      attrs: {
                                        type: "info",
                                        closable: false,
                                        "show-icon": "",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(
                                          " New SKUs to be Created (" +
                                            _vm._s(
                                              _vm.syncPreview.new_skus.length
                                            ) +
                                            "): These SKUs will be auto-created during sync "
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "5px" },
                                        },
                                        _vm._l(
                                          _vm.syncPreview.new_skus,
                                          function (sku) {
                                            return _c(
                                              "el-tag",
                                              {
                                                key: sku,
                                                staticStyle: { margin: "2px" },
                                                attrs: {
                                                  type: "info",
                                                  size: "small",
                                                },
                                              },
                                              [_vm._v(" " + _vm._s(sku) + " ")]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "15px" } },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "250px" },
                      attrs: { placeholder: "Search by package number..." },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.loadPackages.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.packageSearch,
                        callback: function ($$v) {
                          _vm.packageSearch = $$v
                        },
                        expression: "packageSearch",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { slot: "append" },
                          on: { click: _vm.loadPackages },
                          slot: "append",
                        },
                        [_vm._v("Search")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px", "margin-left": "10px" },
                      attrs: { placeholder: "Shipment Status", clearable: "" },
                      on: { change: _vm.loadPackages },
                      model: {
                        value: _vm.packageShipmentStatus,
                        callback: function ($$v) {
                          _vm.packageShipmentStatus = $$v
                        },
                        expression: "packageShipmentStatus",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "All", value: "" } }),
                      _c("el-option", {
                        attrs: { label: "Not Shipped", value: "not_shipped" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Shipped", value: "shipped" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Delivered", value: "delivered" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.loadPackages },
                    },
                    [_vm._v(" Refresh ")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.packagesLoading,
                      expression: "packagesLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.packages },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_number",
                      label: "Package #",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "salesorder_number",
                      label: "Sales Order #",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "customer_name", label: "Customer" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "shipment_status",
                      label: "Shipment Status",
                      width: "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getShipmentStatusType(
                                    row.shipment_status
                                  ),
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(row.shipment_status || "not_shipped")
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "date", label: "Date", width: "120" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Actions", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewPackageDetails(row)
                                  },
                                },
                              },
                              [_vm._v("View")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "Webhook Logs", name: "webhooklogs" } },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "15px" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "Type", clearable: "" },
                      on: { change: _vm.loadWebhookLogs },
                      model: {
                        value: _vm.webhookLogType,
                        callback: function ($$v) {
                          _vm.webhookLogType = $$v
                        },
                        expression: "webhookLogType",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "All", value: "" } }),
                      _c("el-option", {
                        attrs: { label: "Sales Order", value: "salesorder" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Invoice", value: "invoice" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px", "margin-left": "10px" },
                      attrs: { placeholder: "Status", clearable: "" },
                      on: { change: _vm.loadWebhookLogs },
                      model: {
                        value: _vm.webhookLogStatus,
                        callback: function ($$v) {
                          _vm.webhookLogStatus = $$v
                        },
                        expression: "webhookLogStatus",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "All", value: "" } }),
                      _c("el-option", {
                        attrs: { label: "Received", value: "received" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Processing", value: "processing" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Success", value: "success" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Failed", value: "failed" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.loadWebhookLogs },
                    },
                    [_vm._v(" Refresh ")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.webhookLogsLoading,
                      expression: "webhookLogsLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.webhookLogs },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", width: "70" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "webhook_type",
                      label: "Type",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("el-tag", { attrs: { size: "small" } }, [
                              _vm._v(_vm._s(row.webhook_type)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "zoho_number",
                      label: "Zoho #",
                      width: "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "event_type", label: "Event", width: "150" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "status", label: "Status", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getWebhookStatusType(row.status),
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(row.status))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "processing_time_ms",
                      label: "Time",
                      width: "80",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.processing_time_ms
                                    ? row.processing_time_ms + "ms"
                                    : "-"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "created_at", label: "Date", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm._v(
                              " " + _vm._s(_vm.formatDate(row.created_at)) + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Actions", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewWebhookLogDetails(row)
                                  },
                                },
                              },
                              [_vm._v("View")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm.webhookLogsPagination.total > 0
                ? _c("el-pagination", {
                    staticStyle: {
                      "margin-top": "15px",
                      "text-align": "right",
                    },
                    attrs: {
                      "current-page": _vm.webhookLogsPagination.page,
                      "page-size": _vm.webhookLogsPagination.per_page,
                      total: _vm.webhookLogsPagination.total,
                      layout: "total, prev, pager, next",
                    },
                    on: { "current-change": _vm.handleWebhookLogsPageChange },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.webhookLogDetailsVisible,
            title: "Webhook Log Details",
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.webhookLogDetailsVisible = $event
            },
          },
        },
        [
          _vm.selectedWebhookLog
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _c("strong", [_vm._v("ID:")]),
                          _vm._v(" " + _vm._s(_vm.selectedWebhookLog.id)),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Type:")]),
                          _vm._v(
                            " " + _vm._s(_vm.selectedWebhookLog.webhook_type)
                          ),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Event:")]),
                          _vm._v(
                            " " + _vm._s(_vm.selectedWebhookLog.event_type)
                          ),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Zoho ID:")]),
                          _vm._v(" " + _vm._s(_vm.selectedWebhookLog.zoho_id)),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _c("strong", [_vm._v("Zoho Number:")]),
                          _vm._v(
                            " " + _vm._s(_vm.selectedWebhookLog.zoho_number)
                          ),
                        ]),
                        _c(
                          "p",
                          [
                            _c("strong", [_vm._v("Status:")]),
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getWebhookStatusType(
                                    _vm.selectedWebhookLog.status
                                  ),
                                  size: "small",
                                },
                              },
                              [_vm._v(_vm._s(_vm.selectedWebhookLog.status))]
                            ),
                          ],
                          1
                        ),
                        _c("p", [
                          _c("strong", [_vm._v("Processing Time:")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.selectedWebhookLog.processing_time_ms
                                  ? _vm.selectedWebhookLog.processing_time_ms +
                                      "ms"
                                  : "-"
                              )
                          ),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("IP Address:")]),
                          _vm._v(
                            " " + _vm._s(_vm.selectedWebhookLog.ip_address)
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm.selectedWebhookLog.error_message
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "15px" } },
                        [
                          _c("h4", [_vm._v("Error Message")]),
                          _c("el-alert", {
                            attrs: {
                              type: "error",
                              title: _vm.selectedWebhookLog.error_message,
                              closable: false,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("h4", { staticStyle: { "margin-top": "20px" } }, [
                    _vm._v("Payload"),
                  ]),
                  _c(
                    "pre",
                    {
                      staticStyle: {
                        background: "#f5f5f5",
                        padding: "15px",
                        "border-radius": "4px",
                        "max-height": "300px",
                        overflow: "auto",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          JSON.stringify(
                            _vm.selectedWebhookLog.payload,
                            null,
                            2
                          )
                        )
                      ),
                    ]
                  ),
                  _c("h4", { staticStyle: { "margin-top": "20px" } }, [
                    _vm._v("Response"),
                  ]),
                  _c(
                    "pre",
                    {
                      staticStyle: {
                        background: "#f5f5f5",
                        padding: "15px",
                        "border-radius": "4px",
                        "max-height": "200px",
                        overflow: "auto",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          JSON.stringify(
                            _vm.selectedWebhookLog.response,
                            null,
                            2
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.packageDetailsVisible,
            title: "Package Details",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.packageDetailsVisible = $event
            },
          },
        },
        [
          _vm.selectedPackage
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.packageDetailsLoading,
                      expression: "packageDetailsLoading",
                    },
                  ],
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("p", [
                          _c("strong", [_vm._v("Package Number:")]),
                          _vm._v(
                            " " + _vm._s(_vm.selectedPackage.package_number)
                          ),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Sales Order:")]),
                          _vm._v(
                            " " + _vm._s(_vm.selectedPackage.salesorder_number)
                          ),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Customer:")]),
                          _vm._v(
                            " " + _vm._s(_vm.selectedPackage.customer_name)
                          ),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("p", [
                          _c("strong", [_vm._v("Date:")]),
                          _vm._v(" " + _vm._s(_vm.selectedPackage.date)),
                        ]),
                        _c(
                          "p",
                          [
                            _c("strong", [_vm._v("Shipment Status:")]),
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getShipmentStatusType(
                                    _vm.selectedPackage.shipment_status
                                  ),
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.selectedPackage.shipment_status ||
                                        "not_shipped"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("p", [
                          _c("strong", [_vm._v("Package ID:")]),
                          _vm._v(" " + _vm._s(_vm.selectedPackage.package_id)),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Sales Order ID:")]),
                          _vm._v(
                            " " + _vm._s(_vm.selectedPackage.salesorder_id)
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c("h4", { staticStyle: { "margin-top": "20px" } }, [
                    _vm._v("Line Items (with Serial Numbers)"),
                  ]),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.selectedPackage.line_items || [],
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "sku", label: "SKU", width: "180" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "Item Name" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "quantity", label: "Qty", width: "80" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Serial Numbers", "min-width": "300" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  row.serial_numbers &&
                                  row.serial_numbers.length > 0
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          row.serial_numbers,
                                          function (serial) {
                                            return _c(
                                              "el-tag",
                                              {
                                                key: serial,
                                                staticStyle: { margin: "2px" },
                                                attrs: {
                                                  size: "small",
                                                  type: "info",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(serial) + " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    : _c(
                                        "span",
                                        { staticStyle: { color: "#999" } },
                                        [_vm._v("No serial numbers")]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1261348062
                        ),
                      }),
                    ],
                    1
                  ),
                  _c("h4", { staticStyle: { "margin-top": "20px" } }, [
                    _vm._v("Raw Data"),
                  ]),
                  _c(
                    "pre",
                    {
                      staticStyle: {
                        background: "#f5f5f5",
                        padding: "15px",
                        "border-radius": "4px",
                        "max-height": "300px",
                        overflow: "auto",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(JSON.stringify(_vm.selectedPackage, null, 2))
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.orderDetailsVisible,
            title: "Sales Order Details",
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderDetailsVisible = $event
            },
          },
        },
        [
          _vm.selectedOrder
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _c("strong", [_vm._v("Order Number:")]),
                          _vm._v(
                            " " + _vm._s(_vm.selectedOrder.salesorder_number)
                          ),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Status:")]),
                          _vm._v(" " + _vm._s(_vm.selectedOrder.status)),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Customer:")]),
                          _vm._v(" " + _vm._s(_vm.selectedOrder.customer_name)),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("p", [
                          _c("strong", [_vm._v("Email:")]),
                          _vm._v(" " + _vm._s(_vm.selectedOrder.email)),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Date:")]),
                          _vm._v(" " + _vm._s(_vm.selectedOrder.date)),
                        ]),
                        _c("p", [
                          _c("strong", [_vm._v("Total:")]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedOrder.currency_symbol) +
                              _vm._s(_vm.selectedOrder.total)
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c("h4", { staticStyle: { "margin-top": "20px" } }, [
                    _vm._v("Line Items"),
                  ]),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.selectedOrder.line_items || [] },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "sku", label: "SKU", width: "150" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "Item" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "quantity", label: "Qty", width: "80" },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "rate", label: "Rate", width: "100" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "item_total",
                          label: "Total",
                          width: "100",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("h4", { staticStyle: { "margin-top": "20px" } }, [
                    _vm._v("Raw Data"),
                  ]),
                  _c(
                    "pre",
                    {
                      staticStyle: {
                        background: "#f5f5f5",
                        padding: "15px",
                        "border-radius": "4px",
                        "max-height": "300px",
                        overflow: "auto",
                      },
                    },
                    [_vm._v(_vm._s(JSON.stringify(_vm.selectedOrder, null, 2)))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.syncResultsVisible,
            title: "Sync Results",
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.syncResultsVisible = $event
            },
          },
        },
        [
          _vm.syncResults
            ? _c(
                "div",
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { gutter: 20 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-card",
                            {
                              attrs: {
                                shadow: "never",
                                "body-style": {
                                  padding: "20px",
                                  textAlign: "center",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "24px",
                                    "font-weight": "bold",
                                    color: "#67C23A",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.syncResults.summary?.created || 0
                                    )
                                  ),
                                ]
                              ),
                              _c("div", { staticStyle: { color: "#909399" } }, [
                                _vm._v("Devices Created"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-card",
                            {
                              attrs: {
                                shadow: "never",
                                "body-style": {
                                  padding: "20px",
                                  textAlign: "center",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "24px",
                                    "font-weight": "bold",
                                    color: "#409EFF",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.syncResults.summary?.updated || 0
                                    )
                                  ),
                                ]
                              ),
                              _c("div", { staticStyle: { color: "#909399" } }, [
                                _vm._v("Devices Updated"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-card",
                            {
                              attrs: {
                                shadow: "never",
                                "body-style": {
                                  padding: "20px",
                                  textAlign: "center",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "24px",
                                    "font-weight": "bold",
                                    color: "#909399",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.syncResults.summary?.skipped || 0
                                    )
                                  ),
                                ]
                              ),
                              _c("div", { staticStyle: { color: "#909399" } }, [
                                _vm._v("Skipped"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-card",
                            {
                              attrs: {
                                shadow: "never",
                                "body-style": {
                                  padding: "20px",
                                  textAlign: "center",
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "24px",
                                    "font-weight": "bold",
                                    color: "#F56C6C",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.syncResults.summary?.failed || 0)
                                  ),
                                ]
                              ),
                              _c("div", { staticStyle: { color: "#909399" } }, [
                                _vm._v("Failed"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.syncResults.skusCreated &&
                  _vm.syncResults.skusCreated.length > 0
                    ? _c(
                        "div",
                        { staticStyle: { "margin-bottom": "15px" } },
                        [
                          _c(
                            "el-alert",
                            {
                              attrs: {
                                type: "success",
                                closable: false,
                                "show-icon": "",
                              },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(
                                  " New SKUs Created (" +
                                    _vm._s(_vm.syncResults.skusCreated.length) +
                                    ") "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "5px" } },
                                _vm._l(
                                  _vm.syncResults.skusCreated,
                                  function (sku) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: sku,
                                        staticStyle: { margin: "2px" },
                                        attrs: {
                                          type: "success",
                                          size: "small",
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(sku) + " ")]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.syncResultsTab,
                        callback: function ($$v) {
                          _vm.syncResultsTab = $$v
                        },
                        expression: "syncResultsTab",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "Created", name: "created" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.syncResults.details?.created || [],
                                "max-height": "300",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "serial_number",
                                  label: "Serial Number",
                                  width: "200",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sku_code",
                                  label: "SKU",
                                  width: "150",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "package_number",
                                  label: "Package #",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "Updated", name: "updated" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.syncResults.details?.updated || [],
                                "max-height": "300",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "serial_number",
                                  label: "Serial Number",
                                  width: "200",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sku_code",
                                  label: "SKU",
                                  width: "150",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "package_number",
                                  label: "Package #",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "changes", label: "Changes" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "Skipped", name: "skipped" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.syncResults.details?.skipped || [],
                                "max-height": "300",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "serial_number",
                                  label: "Serial Number",
                                  width: "200",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "reason", label: "Reason" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "Failed", name: "failed" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.syncResults.details?.failed || [],
                                "max-height": "300",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "serial_number",
                                  label: "Serial Number",
                                  width: "200",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "error", label: "Error" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }